import React from 'react';
import {useNavigate} from 'react-router';
import {Button} from '@interstate/components/Button';

/**
 * Fail-closed landing (spec 005, FR-008): shown when someone authenticates with Microsoft
 * successfully but has no provisioned access in this app. The SSO callback issued NO session and
 * redirected here — this is an explicit "no access" message, not a broken/empty dashboard.
 */
export default function NoAccess(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="mb-8 text-center">
        <div className="inline-flex items-center gap-2.5 mb-2">
          <div className="w-px h-5 bg-blue-700" />
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">Cox Automotive</span>
        </div>
        <p className="text-xs text-gray-400 tracking-wide">Enterprise Technology &amp; Engineering</p>
      </div>

      <div className="w-full max-w-md bg-white rounded-xl border border-gray-100 shadow-md overflow-hidden">
        <div className="h-1 bg-blue-700" />
        <div className="px-8 py-8">
          <h1 className="text-xl font-bold text-gray-900 mb-1">You don&apos;t have access</h1>
          <p className="text-sm text-gray-500 mb-6">
            Your Microsoft sign-in succeeded, but this account hasn&apos;t been granted access to the
            AIT Leader Dashboard. Contact an administrator to request access, then sign in again.
          </p>
          <Button buttonStyle="primary" type="button" block size="medium" onClick={() => navigate('/', {replace: true})}>
            Back to sign in
          </Button>
        </div>
      </div>
    </div>
  );
}
